import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrNduPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_ndu'
        title='NDU terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'guarantee', subNavType: 'guarantee', subNavPage: 'ndu' }}
      />
    )
  }
}

export default MasterLoanAgrNduPageSF
